import { type ChangeEvent, type KeyboardEvent, useCallback, useState } from 'react';

import c from './_DebugView.module.scss';

function resolveIframeSrc(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return `${window.location.origin}/main`;
  }
  try {
    return new URL(trimmed, window.location.origin).href;
  } catch {
    return `${window.location.origin}/main`;
  }
}

export function DebugView() {
  const defaultSrc = `${window.location.origin}/main`;
  const [input, setInput] = useState(defaultSrc);
  const [iframeSrc, setIframeSrc] = useState(defaultSrc);

  const load = useCallback(() => {
    setIframeSrc(resolveIframeSrc(input));
  }, [input]);

  return (
    <div className={c.root}>
      <div className={c.controls}>
        <input
          className={c.input}
          type="text"
          value={input}
          spellCheck={false}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setInput(e.target.value);
          }}
          onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
            if (e.key === 'Enter') {
              load();
            }
          }}
        />
        <button className={c.loadBtn} type="button" onClick={load}>
          {'Load'}
        </button>
      </div>
      <iframe className={c.frame} key={iframeSrc} title="Debug preview" src={iframeSrc} />
    </div>
  );
}
